import { render } from "./Configuracion2FA.vue?vue&type=template&id=6e92d19a"
import script from "./Configuracion2FA.vue?vue&type=script&lang=js"
export * from "./Configuracion2FA.vue?vue&type=script&lang=js"

import "./Configuracion2FA.vue?vue&type=style&index=0&id=6e92d19a&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__